import {
  getShops
} from "./chunk-UA6USR6Y.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getShopsByIds/getShopsByIds.ts
async function getShopsByIds(shopIds, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getShops");
  try {
    const shops = await getShops({ data: shopIds.slice(0, 30) }, _apiConfig);
    return {
      status: "success",
      data: shops.data ?? {}
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getShopsByIds
};
